import { ZfPill, ZfStack, ZfTextButton, ZfTypography } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { DomicileDto } from '../../../api/generated/client';
import { DomicileDnd } from './DomicileDnd';

interface IProps {
    global: boolean;
    includedIn: DomicileDto[];
    excludedIn: DomicileDto[];
    available: DomicileDto[];
    onChange: (included: DomicileDto[], excluded: DomicileDto[], global: boolean) => void;
}

export const DomicileSelection: FunctionComponent<IProps> = ({ global, includedIn, excludedIn, available, onChange }) => {
    const { t } = useTranslation();

    const [isEditMode, setIsEditMode] = useState(false);

    const handleButtonClick = () => setIsEditMode((prevState) => !prevState);

    return (
        <ZfStack direction="column" spacing="small">
            <ZfTypography variant="label-large" weight="bold">
                {t('contentAdmin.countryScope')}
            </ZfTypography>
            {isEditMode ? (
                <DomicileDnd global={global} onItemsChange={onChange} availableItems={available} excluded={excludedIn} included={includedIn} />
            ) : (
                <ZfStack direction="column" spacing="small">
                    <ZfStack direction="row" spacing="small">
                        <span>{t('contentAdmin.domicileDndGlobal')}</span>
                        <span>{t(`contentAdmin.${global ? 'yes' : 'no'}`)}</span>
                    </ZfStack>
                    <ZfStack direction="row" spacing="small">
                        <ZfTypography>{t('contentAdmin.domicileDndIncluded')}</ZfTypography>
                        {includedIn.length
                            ? includedIn.map((item) => (
                                  <ZfPill key={item.id} color="success" clickable={false}>
                                      {item.countryName}
                                  </ZfPill>
                              ))
                            : t('contentAdmin.none')}
                    </ZfStack>
                    <ZfStack direction="row" spacing="small">
                        <ZfTypography>{t('contentAdmin.domicileDndExcluded')}</ZfTypography>
                        {excludedIn.length
                            ? excludedIn.map((item) => (
                                  <ZfPill key={item.id} color="warning" clickable={false}>
                                      {item.countryName}
                                  </ZfPill>
                              ))
                            : t('contentAdmin.none')}
                    </ZfStack>
                    <ZfTextButton onClick={handleButtonClick} hierarchy="secondary" size="small" style={{ alignSelf: 'start' }}>
                        {isEditMode ? t('contentAdmin.closeButton') : t('contentAdmin.editButton')}
                    </ZfTextButton>
                </ZfStack>
            )}
        </ZfStack>
    );
};
